import { isArray } from 'lodash/fp';

export default function tryParseJson(str, out) {
  try {
    const result = JSON.parse(str);
    Object.assign(out, result);

    if (isArray(result)) {
      // eslint-disable-next-line no-param-reassign
      out.length = result.length;
    }

    return true;
  } catch (e) {
    return false;
  }
}
